import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Pages/Sidebar";
import "./DashboardLayout.scss";

const DashboardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <div className="main-layout">
      {/* Sidebar */}
      <div className={`sidebar-layout ${isSidebarOpen ? "open" : ""}`}>
        <Sidebar />
      </div>

      {/* Backdrop (only for tablet & mobile when sidebar is open) */}
      {isSidebarOpen && <div className="backdrop" onClick={closeSidebar}></div>}

      {/* Page Content */}
      <div className="page-layout">
        {/* Hamburger bar (visible on tablet/mobile) */}
        <div className="hamburger" onClick={toggleSidebar}>
          ☰
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;
